export class MapCondition {
  public formatTypeID: number
  public datasetID: number;
  public sessionID: string;
  public conditionText: string;
  public dataCriteriaCondition: string;
  public ids: string[] = []
  public access: number = 1
  public publicEvents: number = 0
  public restrictedEvents: number = 0
}
